import * as React from 'react';
import VideoArea from "../../containers/VideoArea";

const VideoQALayout = () => (
    <div className="videoQA">
        <VideoArea />
    </div>
)

export default VideoQALayout;
